import React from "react";

const GuideDetailSkeleton = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Hero Section */}
      <div className="h-64 bg-gray-300 animate-pulse relative">
        <div className="absolute bottom-6 left-6">
          <div className="bg-white bg-opacity-75 p-4 rounded">
            <div className="h-4 w-40 bg-gray-200 rounded mb-2 animate-pulse"></div>
            <div className="h-6 w-96 bg-gray-300 rounded animate-pulse"></div>
          </div>
        </div>
      </div>

      <div className="w-full mx-auto px-6 py-10 space-y-8">
        {/* Back Link */}
        <div className="h-4 w-24 bg-gray-300 rounded animate-pulse"></div>

        {/* Paragraph */}
        <div className="bg-white shadow rounded p-6">
          <div className="h-4 bg-gray-200 rounded w-full mb-3 animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6 animate-pulse"></div>
        </div>

        {/* Recommendations Header */}
        <div className="h-6 w-72 bg-gray-300 rounded animate-pulse"></div>

        {/* Recommended Material Card */}
        <div className="bg-white shadow rounded overflow-hidden flex flex-col sm:flex-row">
          <div className="bg-gray-200 w-full sm:w-1/3 h-40 animate-pulse flex items-center justify-center text-sm text-gray-500">
            Image not available
          </div>
          <div className="p-4 flex-1 space-y-3">
            <div className="flex items-center space-x-3">
              <div className="h-6 w-6 bg-orange-400 rounded-full animate-pulse"></div>
              <div className="h-4 w-40 bg-gray-300 rounded animate-pulse"></div>
            </div>
            <div className="h-3 w-3/4 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-3 w-1/2 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuideDetailSkeleton;
